import React from 'react';
import { AddOnItem } from '@hqo/react-components-library/dist/payment/add-on-item';
import { formatCurrency } from 'utils/formatCurrency';
import { useLocale } from 'hooks/use-locale.hook';
import { PaymentDetailsItemContainer } from './styles';
import { AddOnDto } from 'store/add-ons/types';

interface ReceiptDetailsItemProps {
  addOns: Array<AddOnDto>;
  currencyType: string;
}

export const PaymentDetailsItem = ({ addOns, currencyType }: ReceiptDetailsItemProps) => {
  const locale = useLocale();

  return (
    !!addOns?.length && (
      <PaymentDetailsItemContainer>
        {addOns?.map(addOn => (
          <AddOnItem
            key={addOn?.name}
            title={addOn?.name}
            price={formatCurrency(addOn?.price, currencyType, locale)}
            quantity={addOn?.quantity}
          />
        ))}
      </PaymentDetailsItemContainer>
    )
  );
};
